import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AddUsersToTeamMutation,
  AddUsersToTeamMutationVariables,
} from "./AddUsersToTeam.generated";

const ADD_USERS_TO_TEAM: TypedDocumentNode<
  AddUsersToTeamMutation,
  AddUsersToTeamMutationVariables
> = gql`
  mutation addUsersToTeam(
    $addUsersToTeamInput: AddUsersToTeamInput!
  ) {
    addUsersToTeam(addUsersToTeamInput: $addUsersToTeamInput) {
      ok
      provisionedUsers {
        existing {
          success
          email
        }
        newUsers {
          success
          email
        }
      }
    }
  }
`;

export default ADD_USERS_TO_TEAM;
